import {inject, Injectable} from '@angular/core';
import {MatDialog} from '@angular/material/dialog';
import {Alert} from 'src/app/core/model/alert';
import {AlertsModalAlertComponent} from '../alerts/alerts-modal-alert/alerts-modal-alert.component';
import {AlertTypes} from 'src/app/alerts/shared/alert-types';
import {MobileService} from 'src/app/core/page/mobile.service';

@Injectable({
  providedIn: 'root',
})
export class AlertsService {
  private readonly mobileService = inject(MobileService);
  constructor(private dialog: MatDialog) {}

  processAlerts(alerts: Alert[]): void {
    if (!alerts || alerts.length === 0) {
      return;
    }

    for (const alert of alerts) {
      const action = alert.action;
      if (
        action === AlertTypes.TokenEarned ||
        action === AlertTypes.CoinsEarned ||
        action === AlertTypes.Custom ||
        action === AlertTypes.TaskTriggered
      ) {
        this.openAlertModal(alert);
      }
    }
  }

  private openAlertModal(alert: Alert): void {
    this.dialog.open(AlertsModalAlertComponent, {
      autoFocus: this.mobileService.isMobilePlatform() ? false : undefined,
      panelClass: 'alert-modal',
      width: '400px',
      maxHeight: '90vh',
      data: {
        alert: alert,
      },
    });
  }
}
